import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  TuiTextfieldControllerModule,
  TuiTextareaModule,
  TuiInputModule,
  TuiInputDateModule,
  TuiInputNumberModule,
  TuiInputTimeModule,
  TuiInputYearModule,
  TuiSelectModule,
} from '@taiga-ui/legacy';
import { TuiAutoFocus } from '@taiga-ui/cdk';
import { TuiDataList, TuiGroup, TuiButton, TuiHint } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';
import { FieldModule } from '@src/app/shared/field';
import { ComponentsModule } from '@src/app/components';
import { PhoneModule } from '@src/app/modules/phone';
import { ContactsModule } from '@src/app/modules/contacts';
import { RouterModule } from '@angular/router';
import { LogoModule } from '@src/app/modules/logo';
import { LoginModule } from '@src/app/modules/login';
import { SharedModule } from '@src/app/shared';

import { CaptchaModule } from '../captcha';

import { RegistrationComponent } from './registration.component';
import { RegistrationFormComponent } from './components';

@NgModule({
  declarations: [RegistrationComponent, RegistrationFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    FieldModule,
    ComponentsModule,
    TuiButton,
    TuiInputModule,
    TuiTextfieldControllerModule,
    TuiTextareaModule,
    TuiInputYearModule,
    TuiInputDateModule,
    TuiInputTimeModule,
    TuiInputNumberModule,
    ...TuiDataList,
    TuiSelectModule,
    TuiAutoFocus,
    PhoneModule,
    ContactsModule,
    TuiGroup,
    RouterModule,
    LogoModule,
    LoginModule,
    SharedModule,
    ...TuiHint,
    CaptchaModule,
  ],
  exports: [RegistrationComponent],
})
export class RegistrationModule {}
